import Velocity from 'velocity-animate';

import AjaxPage from '../../modules/ajax/ajax-page';
import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './tooltip-image.scss';

import './import/img/volta-block-mobile@1x.jpg';
import './import/img/volta-block-mobile@2x.jpg';
import './import/img/volta-block@0.5x.jpg';
import './import/img/volta-block@0.75x.jpg';
import './import/img/volta-block.jpg';
import './import/img/volta-block@2x.jpg';

import './import/img/volta-kvartal-mobile-v1-310.jpg';
import './import/img/volta-kvartal-mobile-v1-793.jpg';
import './import/img/volta-kvartal-mobile-v1-1122.jpg';
import './import/img/volta-kvartal-mobile-v1-1415.jpg';
import './import/img/volta-kvartal-mobile-v1-1649.jpg';
import './import/img/volta-kvartal-mobile-v1-1870.jpg';
import './import/img/volta-kvartal-mobile-v1-2190.jpg';
import './import/img/volta-kvartal-mobile-v1-2304.jpg';

import './import/img/volta-kvartal-desktop-v1-310.jpg';
import './import/img/volta-kvartal-desktop-v1-1208.jpg';
import './import/img/volta-kvartal-desktop-v1-1761.jpg';
import './import/img/volta-kvartal-desktop-v1-2219.jpg';
import './import/img/volta-kvartal-desktop-v1-2623.jpg';
import './import/img/volta-kvartal-desktop-v1-3152.jpg';
import './import/img/volta-kvartal-desktop-v1-3268.jpg';
import './import/img/volta-kvartal-desktop-v1-3360.jpg';

import './import/img/galerii-loftid-alternate-mobile-310.jpg';
import './import/img/galerii-loftid-alternate-mobile-771.jpg';
import './import/img/galerii-loftid-alternate-mobile-1130.jpg';
import './import/img/galerii-loftid-alternate-mobile-1421.jpg';
import './import/img/galerii-loftid-alternate-mobile-1694.jpg';
import './import/img/galerii-loftid-alternate-mobile-2104.jpg';
import './import/img/galerii-loftid-alternate-mobile-2182.jpg';
import './import/img/galerii-loftid-alternate-mobile-2304.jpg';

import './import/img/galerii-loftid-alternate-desktop-310.jpg';
import './import/img/galerii-loftid-alternate-desktop-1122.jpg';
import './import/img/galerii-loftid-alternate-desktop-1633.jpg';
import './import/img/galerii-loftid-alternate-desktop-2055.jpg';
import './import/img/galerii-loftid-alternate-desktop-2424.jpg';
import './import/img/galerii-loftid-alternate-desktop-2861.jpg';
import './import/img/galerii-loftid-alternate-desktop-3177.jpg';
import './import/img/galerii-loftid-alternate-desktop-3360.jpg';

import './import/img/volta-kvartal-alternate-mobile-310.jpg';
import './import/img/volta-kvartal-alternate-mobile-771.jpg';
import './import/img/volta-kvartal-alternate-mobile-1130.jpg';
import './import/img/volta-kvartal-alternate-mobile-1421.jpg';
import './import/img/volta-kvartal-alternate-mobile-1694.jpg';
import './import/img/volta-kvartal-alternate-mobile-2104.jpg';
import './import/img/volta-kvartal-alternate-mobile-2182.jpg';
import './import/img/volta-kvartal-alternate-mobile-2304.jpg';

import './import/img/volta-kvartal-desktop-310.jpg';
import './import/img/volta-kvartal-desktop-1208.jpg';
import './import/img/volta-kvartal-desktop-1761.jpg';
import './import/img/volta-kvartal-desktop-2219.jpg';
import './import/img/volta-kvartal-desktop-2623.jpg';
import './import/img/volta-kvartal-desktop-3152.jpg';
import './import/img/volta-kvartal-desktop-3268.jpg';
import './import/img/volta-kvartal-desktop-3360.jpg';

import './import/img/volta-kvartal-mobile-310.jpg';
import './import/img/volta-kvartal-mobile-771.jpg';
import './import/img/volta-kvartal-mobile-1130.jpg';
import './import/img/volta-kvartal-mobile-1421.jpg';
import './import/img/volta-kvartal-mobile-1694.jpg';
import './import/img/volta-kvartal-mobile-2104.jpg';
import './import/img/volta-kvartal-mobile-2182.jpg';
import './import/img/volta-kvartal-mobile-2304.jpg';

import './import/img/volta-kvartal-alternate-desktop-310.jpg';
import './import/img/volta-kvartal-alternate-desktop-1208.jpg';
import './import/img/volta-kvartal-alternate-desktop-1761.jpg';
import './import/img/volta-kvartal-alternate-desktop-2219.jpg';
import './import/img/volta-kvartal-alternate-desktop-2623.jpg';
import './import/img/volta-kvartal-alternate-desktop-3152.jpg';
import './import/img/volta-kvartal-alternate-desktop-3268.jpg';
import './import/img/volta-kvartal-alternate-desktop-3360.jpg';

import './import/img/galerii-loftid-mobile-310.jpg';
import './import/img/galerii-loftid-mobile-771.jpg';
import './import/img/galerii-loftid-mobile-1130.jpg';
import './import/img/galerii-loftid-mobile-1421.jpg';
import './import/img/galerii-loftid-mobile-1694.jpg';
import './import/img/galerii-loftid-mobile-2104.jpg';
import './import/img/galerii-loftid-mobile-2182.jpg';
import './import/img/galerii-loftid-mobile-2304.jpg';

import './import/img/galerii-loftid-desktop-310.jpg';
import './import/img/galerii-loftid-desktop-1122.jpg';
import './import/img/galerii-loftid-desktop-1633.jpg';
import './import/img/galerii-loftid-desktop-2055.jpg';
import './import/img/galerii-loftid-desktop-2424.jpg';
import './import/img/galerii-loftid-desktop-2861.jpg';
import './import/img/galerii-loftid-desktop-3177.jpg';
import './import/img/galerii-loftid-desktop-3360.jpg';

import './import/img/volta-kvartal-mobile-alternate-v2-310.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-793.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-1122.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-1415.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-1649.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-1870.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-2190.jpg';
import './import/img/volta-kvartal-mobile-alternate-v2-2304.jpg';

import './import/img/volta-kvartal-desktop-alternate-v1-310.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-1208.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-1761.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-2219.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-2623.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-3152.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-3268.jpg';
import './import/img/volta-kvartal-desktop-alternate-v1-3360.jpg';

import './import/img/galerii-loftid-2026-desktop-310.jpg';
import './import/img/galerii-loftid-2026-desktop-1122.jpg';
import './import/img/galerii-loftid-2026-desktop-1633.jpg';
import './import/img/galerii-loftid-2026-desktop-2055.jpg';
import './import/img/galerii-loftid-2026-desktop-2424.jpg';
import './import/img/galerii-loftid-2026-desktop-2861.jpg';
import './import/img/galerii-loftid-2026-desktop-3177.jpg';
import './import/img/galerii-loftid-2026-desktop-3360.jpg';

import './import/img/galerii-loftid-2026-mobile-310.jpg';
import './import/img/galerii-loftid-2026-mobile-771.jpg';
import './import/img/galerii-loftid-2026-mobile-1130.jpg';
import './import/img/galerii-loftid-2026-mobile-1421.jpg';
import './import/img/galerii-loftid-2026-mobile-1694.jpg';
import './import/img/galerii-loftid-2026-mobile-2104.jpg';
import './import/img/galerii-loftid-2026-mobile-2182.jpg';
import './import/img/galerii-loftid-2026-mobile-2304.jpg';

import './import/img/progress-background-transparent.png';

interface ITooltipImageSettings {
    descriptionSelector: string;
    hoverContentSelector: string;
    hoveringClass: string;
    initClass: string;
    pathSelector: string;
    tooltipSelector: string;
}

export default class TooltipImage extends Component {
    static initSelector: string = '.tooltip-image';

    hoverIDs: string[] = [];
    paths: JQuery;
    settings: ITooltipImageSettings;
    tooltips: JQuery;
    scrollToTooltips: JQuery;
    timeoutIds: WeakMap<HTMLElement, ReturnType<typeof setTimeout>>;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            descriptionSelector: '.tooltip-image__description',
            hoverContentSelector: '.tooltip-image__hover-content',
            hoveringClass: 'is-hovering',
            initClass: 'has-initialized',
            pathSelector: '.tooltip-image__path',
            tooltipSelector: '.tooltip-image__tooltip',
        };

        this.tooltips = this.element.find(this.settings.tooltipSelector).filter('a');
        this.paths = this.element.find(this.settings.pathSelector);
        this.scrollToTooltips = this.tooltips.filter('[href^="#"]');

        this.timeoutIds = new WeakMap();

        this.init();
    }

    init(): void {
        this.paths.on('click', this.onMouseClick.bind(this));
        this.scrollToTooltips.on('click', this.onScrollToClick.bind(this));

        this.removeSoldPaths();

        if (!Helpers.isMobileDevice) {
            this.prepareHoverContent();

            this.paths.on('mouseenter', this.onMouseEnter.bind(this));
            this.paths.on('mouseleave', this.onMouseLeave.bind(this));

            this.tooltips.on('mouseenter', this.onMouseEnterTooltip.bind(this));
            this.tooltips.on('mouseleave', this.onMouseLeaveTooltip.bind(this));

            this.element.addClass(this.settings.initClass);
        }
    }

    removeSoldPaths(): void {
        this.paths.each(((_index: number, element: HTMLElement) => {
            if (!this.tooltips.is(`[data-id="${element.getAttribute('data-target')}"]`)) {
                element.remove();
            }
        }));
    }

    isInArray(s: string): boolean {
        return jQuery.inArray(s, this.hoverIDs) !== -1;
    }

    prepareHoverContent(): void {
        Velocity(this.element.find(this.settings.hoverContentSelector), {
            height: 0,
        }, {
            duration: 200,
            easing: 'linear',
        });
    }

    onScrollToClick(event: JQuery.TriggeredEvent): void {
        const target: JQuery = $($(event.currentTarget).attr('href'));

        event.preventDefault();

        if (target.length > 0) {
            Helpers.scrollToTarget(target);
        }
    }

    onMouseClick(event: JQuery.TriggeredEvent): void {
        const path: JQuery = $(event.currentTarget);
        const tooltip: JQuery = this.element.find(`[data-id='${path.data('target')}']`);

        if (tooltip.attr('href')) {
            const url: string = tooltip.attr('href');

            if (gotoAndPlay.ajax.isEnabled) {
                AjaxPage.changePage(url);
            } else {
                window.location.href = tooltip.attr('href');
            }
        }
    }

    onMouseEnter(event: JQuery.TriggeredEvent): void {
        const path: JQuery = $(event.currentTarget);
        const tooltip: JQuery = this.element.find(`[data-id='${path.data('target')}']`);

        const timeoutId: ReturnType<typeof setTimeout> = this.timeoutIds.get(path[0]);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        if (tooltip.length > 0 && !this.isInArray(path.data('target'))) {
            this.hoverIDs.push(path.data('target'));

            this.animationBegin(path, tooltip);
        }
    }

    onMouseLeave(event: JQuery.TriggeredEvent): void {
        const path: JQuery = $(event.currentTarget);
        const tooltip: JQuery = this.element.find(`[data-id='${path.data('target')}']`);

        const timeoutId: ReturnType<typeof setTimeout> = this.timeoutIds.get(path[0]);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        this.timeoutIds.set(path[0], setTimeout(() => {
            if (tooltip.length > 0) {
                this.hoverIDs = this.hoverIDs.filter((s: string) => s !== path.data('target'));

                this.animationEnd(path, tooltip);
            }
        }, 200));
    }

    onMouseEnterTooltip(event: JQuery.TriggeredEvent): void {
        const tooltip: JQuery = $(event.currentTarget);
        const path: JQuery = this.element.find(`[data-target='${tooltip.data('id')}']`);

        const timeoutId: ReturnType<typeof setTimeout> = this.timeoutIds.get(path[0]);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        if (path.length > 0 && !this.isInArray(tooltip.data('id'))) {
            this.hoverIDs.push(tooltip.data('id'));
        }

        this.animationBegin(path, tooltip);
    }

    onMouseLeaveTooltip(event: JQuery.TriggeredEvent): void {
        const tooltip: JQuery = $(event.currentTarget);
        const path: JQuery = this.element.find(`[data-target='${tooltip.data('id')}']`);

        const timeoutId: ReturnType<typeof setTimeout> = this.timeoutIds.get(path[0]);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        this.timeoutIds.set(path[0], setTimeout(() => {
            if (path.length > 0) {
                this.hoverIDs = this.hoverIDs.filter((s: string) => s !== tooltip.data('id'));
            }

            this.animationEnd(path, tooltip);
        }, 200));

    }

    animationBegin(path: JQuery, tooltip: JQuery): void {
        tooltip.addClass(this.settings.hoveringClass);
        path.addClass(this.settings.hoveringClass);

        this.hideDescription(tooltip);
    }

    animationEnd(path: JQuery, tooltip: JQuery): void {
        tooltip.removeClass(this.settings.hoveringClass);
        path.removeClass(this.settings.hoveringClass);

        if (!this.isInArray(tooltip.data('id'))) {
            this.showDescription(tooltip);
        } else {
            this.hideDescription(tooltip);
        }
    }

    hideDescription(tooltip: JQuery): void {
        const description: JQuery = tooltip.find(this.settings.descriptionSelector);
        const hoverContent: JQuery = tooltip.find(this.settings.hoverContentSelector);

        if (hoverContent.length > 0 && tooltip.hasClass(this.settings.hoveringClass)) {
            Velocity(description, {
                height: 0,
            }, {
                duration: 200,
                easing: 'linear',
            });

            Velocity(hoverContent, {
                height: hoverContent.find('.tooltip-image__hover-content-inner').height(),
            }, {
                duration: 200,
                easing: 'linear',
            });
        }
    }

    showDescription(tooltip: JQuery): void {
        const description: JQuery = tooltip.find(this.settings.descriptionSelector);
        const hoverContent: JQuery = tooltip.find(this.settings.hoverContentSelector);

        if (hoverContent.length > 0 && !tooltip.hasClass(this.settings.hoveringClass)) {
            Velocity(hoverContent, {
                height: 0,
            }, {
                duration: 200,
                easing: 'linear',
            });

            Velocity(description, {
                height: description.find('.tooltip-image__description-inner').height(),
            }, {
                duration: 200,
                easing: 'linear',
            });
        }
    }
}
